import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PageLoader } from "./components/page-loader";
import { AuthenticationGuard } from "./components/authentication-guard";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Athletes from "./pages/athlete/Athletes";
import CreateAthleteForm from "./pages/athlete/CreateAthleteForm";
import EditAthleteForm from "./pages/athlete/EditAthleteForm";
import Exercises from "./pages/exercise/Exercises";
import CreateExerciseForm from "./pages/exercise/CreateExerciseForm";
import EditExerciseForm from "./pages/exercise/EditExerciseForm";
import Programs from "./pages/program/Programs";
import CreateProgram from "./pages/program/CreateProgram";
import Workouts from "./pages/workout/Workouts";
import CreateWorkoutForm from "./pages/workout/CreateWorkoutForm";
import EditWorkoutForm from "./pages/workout/EditWorkoutForm";
import EditProgram from "./pages/program/EditProgram";
import ManageAthlete from "./pages/athlete/ManageAthlete";
import { useCoach } from "./hooks/useCoach";
import Coaches from "./pages/coach/Coaches";
import CreateCoachForm from "./pages/coach/CreateCoachForm";
import CoachForm from "./pages/coach/EditCoachForm";
import KnowBase from "./pages/knowbase/KnowBase";
import CreateKnowBase from "./pages/knowbase/CreateKnowBase";
import EditKnowBase from "./pages/knowbase/EditKnowBase";
import Foods from "./pages/food/Foods";
import CreateFood from "./pages/food/CreateFood";
import EditFood from "./pages/food/EditFood";
import MealPlanMaker from "./components/nutrition/MealPlanMaker";
import NewCreateProgram from "./pages/program/NewCreateProgram";
import NewEditProgram from "./pages/program/NewEditProgram";

export const App = () => {
  const { coach, isLoading: coachLoading } = useCoach();

  // Mostrar loader mientras se cargan los datos del coach
  if (coachLoading) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    );
  }

  // Verificar si el coach tiene el rol de "admin"
  const isAdmin = coach?.role === "admin";
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/mealplanmaker" element={<MealPlanMaker/>}/>
      {/* Rutas para el rol de "admin" */}
      {isAdmin && (
        <>
          <Route path="/dashboard" element={<AuthenticationGuard component={Dashboard} />} />
          <Route path="/athletes" element={<AuthenticationGuard component={Athletes} />} />
          <Route path="/athlete/create" element={<AuthenticationGuard component={CreateAthleteForm} />} />
          <Route path="/athlete/:id" element={<AuthenticationGuard component={EditAthleteForm} />} />
          <Route path="/manage/athlete/:id" element={<AuthenticationGuard component={ManageAthlete} />} />
          <Route path="/exercises" element={<AuthenticationGuard component={Exercises} />} />
          <Route path="/exercise/create" element={<AuthenticationGuard component={CreateExerciseForm} />} />
          <Route path="/exercise/:id" element={<AuthenticationGuard component={EditExerciseForm} />} />
          <Route path="/programs" element={<AuthenticationGuard component={Programs} />} />
          <Route path="/program/create" element={<AuthenticationGuard component={CreateProgram} />} />
          <Route path="/program/designer" element={<AuthenticationGuard component={NewCreateProgram} />} />
          <Route path="/program/:id" element={<AuthenticationGuard component={EditProgram} />} />
          <Route path="/program/designer/:id" element={<AuthenticationGuard component={NewEditProgram} />} />
          <Route path="/workouts" element={<AuthenticationGuard component={Workouts} />} />
          <Route path="/workout/create" element={<AuthenticationGuard component={CreateWorkoutForm} />} />
          <Route path="/workout/:id" element={<AuthenticationGuard component={EditWorkoutForm} />} />
          <Route path="/coaches" element={<AuthenticationGuard component={Coaches} />} />
          <Route path="/coach/create" element={<AuthenticationGuard component={CreateCoachForm} />} />
          <Route path="/coach/:id" element={<AuthenticationGuard component={CoachForm} />} />
          <Route path="/knowbase/" element={<AuthenticationGuard component={KnowBase} />} />
          <Route path="/knowbase/create" element={<AuthenticationGuard component={CreateKnowBase} />} />
          <Route path="/knowbase/:id" element={<AuthenticationGuard component={EditKnowBase} />} />
          <Route path="/foods/" element={<AuthenticationGuard component={Foods} />} />
          <Route path="/food/create" element={<AuthenticationGuard component={CreateFood} />} />
          <Route path="/food/:id" element={<AuthenticationGuard component={EditFood} />} />
        </>
      )}

      {/* Rutas para otros roles (no "admin") */}
      {!isAdmin && (
         <>
         <Route path="/dashboard" element={<AuthenticationGuard component={Dashboard} />} />
         <Route path="/athletes" element={<AuthenticationGuard component={Athletes} />} />
         <Route path="/athlete/create" element={<AuthenticationGuard component={CreateAthleteForm} />} />
         <Route path="/athlete/:id" element={<AuthenticationGuard component={EditAthleteForm} />} />
         <Route path="/manage/athlete/:id" element={<AuthenticationGuard component={ManageAthlete} />} />
         <Route path="/exercises" element={<AuthenticationGuard component={Exercises} />} />
         <Route path="/exercise/create" element={<AuthenticationGuard component={CreateExerciseForm} />} />
         <Route path="/exercise/:id" element={<AuthenticationGuard component={EditExerciseForm} />} />
         <Route path="/programs" element={<AuthenticationGuard component={Programs} />} />
         <Route path="/program/create" element={<AuthenticationGuard component={CreateProgram} />} />
         <Route path="/program/:id" element={<AuthenticationGuard component={EditProgram} />} />
         <Route path="/workouts" element={<AuthenticationGuard component={Workouts} />} />
         <Route path="/workout/create" element={<AuthenticationGuard component={CreateWorkoutForm} />} />
         <Route path="/workout/:id" element={<AuthenticationGuard component={EditWorkoutForm} />} />
         <Route path="/knowbase/" element={<AuthenticationGuard component={KnowBase} />} />
         <Route path="/knowbase/create" element={<AuthenticationGuard component={CreateKnowBase} />} />
         <Route path="/knowbase/:id" element={<AuthenticationGuard component={EditKnowBase} />} />
         <Route path="/mealplanmaker/" element={<AuthenticationGuard component={MealPlanMaker} />} />
       </>
      )}

    </Routes>
  );
};
